// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1t4Tk","list":"PatternAutocomplete_list__1Vnlt"};